<template lang="html">
    <div class="text-page">
        <top-nav></top-nav>

        <div class="text-page-hero" :style="{ backgroundImage: bgImg }"></div>

        <page-title :title="currentPage.title"></page-title>

        <div class="viveco-footer-background">
            <div class="container">
                <div class="page-body" v-html="currentPage.body"></div>
            </div>
        </div>

        <page-footer></page-footer>
    </div>
</template>

<script>
import topNav from '../ui/top-nav.vue';
import pageTitle from '../ui/page-title.vue';
import pageFooter from '../ui/page-footer.vue';

export default {
    components: {
        topNav,
        pageTitle,
        pageFooter
    },
    data() {
        return {
            page: {
                title: 'Mentions Légales',
                //img: '/static/img/josh-boot-177342.jpg',
                img: '/static/img/ant-rozetsky-140870.jpg',
                body: ''
            }
        };
    },
    computed: {
        bgImg() {
            return 'url(' + this.page.img + ')';
        },
        currentPage() {
            return this.page;
        }
    }
};
</script>

<style lang="less">
.text-page {
    .text-page-hero {
        background-position: center center;
        background-size: cover;
        min-height: 40vh;
    }
    h3 {
        font-weight: bold;
        text-transform: uppercase;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/page.vue